import Vue from 'vue';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueRouter from 'vue-router';
import router from './router';
import Index from './Index';

import { Signer } from '@waves/signer';

import rare from './rare';
import zombie from './zombie'

Vue.router = router;
Vue.use(VueRouter);
Vue.use(VueAxios, axios);

window.rare = rare;
window.zombie = zombie;

window.nodeURL = 'https://nodes.wavesnodes.com';
// window.nodeURL = 'https://nodes-testnet.wavesnodes.com';

window.signer = new Signer();
// window.signer = new Signer({
//     NODE_URL: window.nodeURL
// });

window.contractAddress = '3P8rLVnwrTf4k5AB3emuduhZZb1yKcitTHy';
window.zombieAddress = '3P7QrWH1ETLfKAJcFHYPJmQusNbDuW98Hop';
// window.contractAddress = '3N5aN5RqVqtb8HbNghuNb1NygjYPFRKfE7E';
// window.zombieAddress = '3MydZBLyjvR1dzf6nzucCbpCDZgaL4zWPwg';

window.madEmpireAddress = '';
window.madFreeAddress = '';
window.madMutationAddress = '';

window.marketAddress = '3P2m8mf5M9yRUVgYzATiiK8wDTd4pHDiFLs';

if (window.location.href.indexOf('mypunks.wavespunks.com') > -1 || window.location.href.indexOf('ost:') > -1 || window.location.href.indexOf('mypunks-app.pages.dev') > -1)
    new Vue({
        render: h => h(Index),
        el: '#app',
        router
    });